<template>
  <div class="Login d-flex justify-content-center align-items-center">
    <card class="card">
      <h3>Login</h3>

      <div>
        <FormInput
          class="form-element"
          v-model="$v.email.$model"

          id="email"
          label="Email"
          autocomplete="email"
          type="email"

          :vuelidate="$v"
          fieldName="email"
          @keydown.enter="login"
        />
        <FormInput
          class="form-element"
          v-model="$v.password.$model"

          id="password"
          label="Password"
          type="password"

          :vuelidate="$v"
          fieldName="password"
          @keydown.enter="login"
        />
        <input id="submit"
          type="submit"
          value="Log In"
          class="btn btn-block btn-primary"

          @click.prevent="login"
        >
      </div>
    </card>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators"

import FormInput from "src/components/Inputs/FormInput.vue"

export default {
  components: {
    FormInput,
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  data() {
    return {
      email: "",
      password: "",
    }
  },
  computed: {
    lastVisitedPage() {
      return localStorage.getItem("last-admin-page") || "/admin/websites"
    },
  },
  methods: {
    async login() {
      this.$v.$touch()
      if (this.$v.$error) return;

      this.$store.commit("clearCache")
      if (await this.$handlePromise(
        this.axios.post("/login", {
          email: this.$v.email.$model,
          password: this.$v.password.$model,
        }), true, "Verkeerd wachtwoord of e-mailadres"
      )) {
        this.$router.push(this.lastVisitedPage).catch(()=>{})
      }
    },
  },
}

</script>

<style scoped>

.card {
  flex-basis: 500px;
  margin: 0 8px;
  padding: 34px;
}

.Login {
  height: 100vh;
}

h3 {
  color: #888888;
  margin: 0;
  padding: 0;
  margin-bottom: 18px;
}

.btn {
  padding: 10px;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

</style>
